<template>
    <div class="wrapper">
<!--        <div-->
<!--                class="page-header header-filter clear-filter"-->
<!--                style="background: #3F7CB3"-->
<!--        >-->
            <div class="md-layout">
                <div class="md-layout-item">
                    <div class="image-wrapper">
                        <div class="brand" >
                          <span class="md-display-3 text-center" style="color: white;">Приложения для автоматизации </span>
                            <br>
                            <span class="md-display-3" style="color: white;">мобильной торговли</span>
                            <h3 class="title">
                                Бесплатная интеграция в 1С:Предприятие за 30 минут.
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
<!--    </div>-->
</template>

<script>
  export default {
    name: "BlockMain"
  }
</script>

<style lang="scss">
    .mh{
        font-size: 40px !important;
    }
    .presentation-page .brand h3 {
        font-size: 1.313rem;
        max-width: 500px;
        margin: 10px auto 0;
        text-shadow: 0px 15px 102.86px rgb(0 0 0 / 0%), 0px 15px 40.02px rgb(0 0 0 / 0%) !important;
    }
    @media screen and (max-width: 540px) {
        .md-display-3{
            font-size: 40px !important;
        }
    }
    @media screen and (max-width: 376px) {
        .md-display-3{
            font-size: 40px !important;
        }
    }
    @media screen and (max-width: 450px) {
        .md-display-3{
            font-size: 30px;
        }
    }

</style>